"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARAM_OPTIONS_SYMBOL = Symbol.for('isParam');
function isParamGuard(data) {
    return !!data && !!data[exports.PARAM_OPTIONS_SYMBOL];
}
exports.isParamGuard = isParamGuard;
function isRawRouteTree(value) {
    var isOnlyParam = isParamGuard(value) && !Object.keys(value).length;
    var isNull = value === null;
    return !isNull && !isOnlyParam;
}
exports.isRawRouteTree = isRawRouteTree;
